"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@workspace/ui/components/tooltip";
import { UserAvatar } from "@workspace/ui/components/avatar";
import Link from "next/link";
import { ExternalLink } from "lucide-react";

interface UserHoverCardProps {
  username: string;
  children: React.ReactNode;
}

export function UserHoverCard({ username, children }: UserHoverCardProps) {
  return (
    <TooltipProvider delayDuration={400}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent
          side="left"
          className="w-48 p-0"
          sideOffset={8}
        >
          <div className="p-3 space-y-2">
            <div className="flex items-center gap-2">
              <UserAvatar username={username} email="" size="lg" className="h-8 w-8" />
              <div className="min-w-0">
                <div className="text-base font-medium truncate">{username}</div>
              </div>
            </div>
            <Link
              href={`/profile/${encodeURIComponent(username)}`}
              className="flex items-center gap-1 text-sm text-primary hover:underline"
            >
              <ExternalLink className="h-3 w-3" />
              View profile
            </Link>
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
